export default "__VITE_ASSET__CJsMqhT6__"